import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

import { themeColor } from 'constants/index';
import cn from 'utils/classnames';

import styles from './AppButton.module.scss';

const AppButton = (props) => {
  const {
    disabled,
    loading,
    outline,
    isDefault,

    classes,
    color,
    fontSize,
    name,
    type,
    value,

    children,

    onClick,
    ...rest
  } = props;

  const onClickButton = (event) => {
    onClick(value || event);
  };

  if (isDefault) {
    return (
      <button
        value={value}
        // eslint-disable-next-line react/button-has-type
        type={type}
        disabled={disabled}
        onClick={value ? onClickButton : onClick}
        {...props}
        {...rest}
        className={classes}
      >
        {children}
      </button>
    );
  }

  return (
    <Button
      type={type}
      color={color}
      disabled={loading || disabled}
      style={{ fontSize }}
      value={value}
      outline={outline}
      onClick={value ? onClickButton : onClick}
      {...rest}
      className={cn(styles.Component, classes)}
    >
      {
        !loading ? children
          : (
            <>
              <i className="bx bx-loader bx-spin align-middle me-1" />
              {`${name}...`}
            </>
          )
      }
    </Button>
  );
};

AppButton.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  outline: PropTypes.bool,
  isDefault: PropTypes.bool,

  name: PropTypes.string,
  classes: PropTypes.string,
  fontSize: PropTypes.string,
  color: PropTypes.oneOf([
    themeColor.PRIMARY,
    themeColor.SECONDARY,
    themeColor.DANGER,
    themeColor.INFO,
    themeColor.LIGHT,
    themeColor.LINK,
    themeColor.SUCCESS,
    themeColor.WARNING,
  ]),
  type: PropTypes.string,
  value: PropTypes.node,

  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Object),
  ]),

  onClick: PropTypes.func,
};

AppButton.defaultProps = {
  disabled: false,
  loading: false,
  outline: false,
  isDefault: false,

  children: '',
  classes: '',
  color: themeColor.PRIMARY,
  fontSize: '',
  name: 'Đang gửi',
  type: 'button',
  value: null,

  onClick: () => { },
};

export default memo(AppButton);
